import React, { useEffect } from "react";
import useSignOut from "../../utils/sign-out";

function SignOut() {
  const signOut = useSignOut();
  useEffect(() => {
    signOut({ isNavigate: true });
  });
  return <div></div>;
}

export default SignOut;
